import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

const GOLD = "#C7A668";
const WHATSAPP_NUMBER = "525578988731";

export default function AutosFooter({ lang: langProp }) {
  const { L } = useLang(); // eslint-disable-line no-unused-vars
  const en = langProp === "en";
  const p = {
    services: en ? "/en/cars" : "/autos",
    memberships: en ? "/en/cars/memberships" : "/autos/membresias",
    aviation: en ? "/en/aviation" : "/aviacion",
    privacy: en ? "/en/legal" : "/legal",
    door: en ? "/en" : "/",
    altLang: en ? "/autos" : "/en/cars",
  };
  const contactHref = `https://wa.me/${WHATSAPP_NUMBER}`;

  return (
    <footer className="footer-solid border-t border-white/8 px-6 md:px-16" style={{ paddingTop: 64, paddingBottom: 48 }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-[1.4fr_1fr] gap-12">
          <div>
            <Link to={p.door} className="no-underline font-display" data-testid="footer-brand" style={{ fontSize: 26, color: "#F2EFE8", letterSpacing: ".12em", fontWeight: 300 }}>DUKK</Link>
            <p style={{ color: "#7a808a", fontSize: 13, lineHeight: 1.8, maxWidth: 640, fontWeight: 300, marginTop: 16 }}>
              {en
                ? "Dukk provides premium mobile car care and detailing in Mexico — hand washing, leather conditioning, carpet extraction, paint correction, ceramic coating and PPF, at your home, garage or office. The same standard we bring to private jets, for the car you drive every day."
                : "Dukk ofrece lavado premium y detailing de autos a domicilio en México — lavado a mano, acondicionado de piel, extracción de alfombras, corrección de pintura, recubrimiento cerámico y PPF, en tu casa, garaje u oficina. El mismo estándar que llevamos a los jets privados, para el auto que manejas todos los días."}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col gap-3">
              <Link to={p.services} data-testid="footer-services" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "Services" : "Servicios"}</Link>
              <Link to={p.memberships} data-testid="footer-memberships" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "Memberships" : "Membresías"}</Link>
              <Link to={en ? "/en/garage" : "/garaje"} data-testid="footer-garage" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "The Garage" : "El Garaje"}</Link>
              <Link to={p.aviation} data-testid="footer-aviation" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "Aviation" : "Aviación"}</Link>
            </div>
            <div className="flex flex-col gap-3">
              <a href={contactHref} target="_blank" rel="noreferrer" data-testid="footer-contact" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "Contact" : "Contacto"}</a>
              <Link to={p.privacy} data-testid="footer-privacy" className="no-underline" style={{ color: "#B8BDC3", fontSize: 13.5 }}>{en ? "Privacy Notice" : "Aviso de Privacidad"}</Link>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-white/8" style={{ marginTop: 40, paddingTop: 24 }}>
          <span style={{ color: "#5c626b", fontSize: 12 }}>© {new Date().getFullYear()} Dukk. {en ? "All rights reserved." : "Todos los derechos reservados."}</span>
          <div className="flex items-center gap-4">
            <Link to={p.altLang} data-testid="footer-lang" className="no-underline font-mono" style={{ color: "#B8BDC3", fontSize: 11.5, letterSpacing: ".1em", border: "1px solid rgba(255,255,255,.18)", borderRadius: 4, padding: "5px 12px" }}>{en ? "ES" : "EN"}</Link>
            <Link to={p.aviation} data-testid="footer-world" className="no-underline font-mono" style={{ color: GOLD, fontSize: 11.5, letterSpacing: ".08em", border: "1px solid rgba(199,166,104,.4)", borderRadius: 999, padding: "5px 14px" }}>{en ? "Aviation →" : "Aviación →"}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
